export const getAccessTokenFromStorage = () => {
  let user = JSON.parse(localStorage.getItem("user"))
  return user ? user.access : null
};

export const setAccessTokenAtStorage = (email, token) => {
  localStorage.setItem("user", JSON.stringify({ email, access: token }))
};
